import { theme } from 'antd'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useMemo } from 'react'

export const PostViews = ({ averageViews = 0, title = 'Ср. Просмотры', height = 400 }) => {
    const {
        token: { colorBgElevated, colorText }
    } = theme.useToken()

    const options = useMemo(() => {
        return {
            chart: {
                type: 'solidgauge',
                height,
                borderRadius: 10,
                backgroundColor: colorBgElevated
            },
            credits: { enabled: false },
            title: {
                text: title,
                style: { fontSize: '20px', color: colorText }
            },
            pane: {
                center: ['50%', '85%'],
                size: '100%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor: '#EEE',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc',
                    borderRadius: 5
                }
            },
            exporting: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            yAxis: {
                min: 0,
                max: 100,
                stops: [
                    [0.1, '#55BF3B'],
                    [0.5, '#DDDF0D'],
                    [0.9, '#DF5353']
                ],
                lineWidth: 0,
                tickWidth: 0,
                minorTickInterval: undefined,
                tickAmount: 2,
                labels: {
                    y: 16,
                    style: { color: colorText }
                }
            },
            plotOptions: {
                solidgauge: {
                    borderRadius: 3,
                    dataLabels: {
                        y: -20,
                        borderWidth: 0,
                        useHTML: true,
                        format: '<div style="text-align:center"><span style="font-size:24px">{y}%</span></div>'
                    }
                }
            },
            series: [
                {
                    type: 'solidgauge',
                    data: [averageViews]
                }
            ]
        }
    }, [averageViews, colorBgElevated, colorText, title])

    return (
        <div className="w-full">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    )
}
